import { render } from "./ThongBao.vue?vue&type=template&id=18b01b14&scoped=true"
import script from "./ThongBao.vue?vue&type=script&lang=js"
export * from "./ThongBao.vue?vue&type=script&lang=js"

import "./ThongBao.vue?vue&type=style&index=0&id=18b01b14&lang=css"
import "./ThongBao.vue?vue&type=style&index=1&id=18b01b14&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b01b14"]])

export default __exports__